module.exports = __webpack_public_path__ + "img/hill29.233f9951.jpg";